import React from 'react';
import {Link} from 'react-router-dom';
import i18n from 'i18n-react';
export default class HomeDestacado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      locale: this.props.locale,
      windowHeight: window.innerHeight / 2
    };
    this.destacadoStyle = {
      height: this.state.windowHeight + 'px'
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResizeHandler.bind(this));
  }

  onResizeHandler() {
    this.setState({windowHeight: window.innerHeight / 2});
    this.sliderStyle = {
      height: this.state.windowHeight + 'px'
    };
  }

  render() {
    return (
      <div className={"destacado destacado" + this.state.id} style={this.destacadoStyle}>
        <div className="col">
          <p>
            <i18n.span text={{key: this.state.locale + ".home.destacados.destacado" + this.state.id + ".texto1"}}/>
            <i18n.span text={{key: this.state.locale + ".home.destacados.destacado" + this.state.id + ".texto2"}}/>
          </p>
        </div>
        <div className="col">
          <Link to="#" className="boton">
            <i18n.span text={{key: this.state.locale + ".home.destacados.destacado" + this.state.id + ".boton"}}/>
          </Link></div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/HomeDestacado.js